import Nav from  "../../components/Nav"
import Footer from "../../components/Footer"
import ContentAutor from "../../components/ContentAutor"

const Autor = () => {
  return(
    <>
    <Nav />
    <ContentAutor />
    <Footer />
    </>
  )
}

export default Autor